// src/utils/useWebSocket.js
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { setInitialData, updateSingleItem } from "../store/wsSlice";

export default function useWebSocket(token) {
  const wsRef = useRef(null);
  const reconnectTimer = useRef(null);
  const backoff = useRef(1000);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!token) return;
    const WS_URL = `wss://www.ciaowin35.com/ws?type=ems&token=${token}`;

    function connect() {
      if (wsRef.current) {
        wsRef.current.close();
      }
      wsRef.current = new WebSocket(WS_URL);

      wsRef.current.onopen = () => {
        // console.log("✅ WebSocket connected:", WS_URL);
        backoff.current = 1000;
      };

      wsRef.current.onmessage = (event) => {
        try {
          const parsedData = JSON.parse(event.data);

          // 判斷是初始完整資料還是單筆更新
          if (Array.isArray(parsedData.data)) {
            // 初始完整資料
            dispatch(setInitialData(parsedData.data));
            console.log("✅ 接收初始完整資料:", parsedData.data.length, "筆");
          } else if (parsedData.data && parsedData.data.id) {
            // 單筆更新資料
            dispatch(updateSingleItem(parsedData.data));
            // console.log("🔄 更新單筆資料 ID:", parsedData.data.id);
          } else {
            console.warn("⚠️ 未知的資料格式:", parsedData);
          }
        } catch (e) {
          console.error("❌ WebSocket parse error:", e, "Raw:", event.data);
        }
      };
      wsRef.current.onerror = (error) =>
        console.error("⚠️ WebSocket error:", error);

      wsRef.current.onclose = (e) => {
        console.log(
          `⚠️ WebSocket disconnected (code: ${e.code}). Reconnecting in ${
            backoff.current / 1000
          }s`
        );
        reconnectTimer.current = setTimeout(() => {
          backoff.current = Math.min(backoff.current * 2, 30000);
          connect();
        }, backoff.current);
      };
    }

    connect();

    return () => {
      if (reconnectTimer.current) clearTimeout(reconnectTimer.current);
      if (wsRef.current) {
        wsRef.current.onopen = null;
        wsRef.current.onmessage = null;
        wsRef.current.onerror = null;
        wsRef.current.onclose = null;
        wsRef.current.close();
      }
    };
  }, [token, dispatch]);
}
